//A mixin for enhancing an object with event generation capabilities (promoting loose coupling).
//Use some flavor of extend(), for example, to add it to your object.

export default {

  events: null,

  addEventListener: function(eventName, callback)
  {
    this.events = this.events || {};

    this.events[eventName] = this.events[eventName] || [];
    this.events[eventName].push(callback);
  },

  removeEventListener: function(eventName, callback)
  {
    this.events = this.events || {};

    if(!(eventName && callback))
      return;

    var callbacks = this.events[eventName];
    if(callbacks)
    {
      for(var i = 0; i < callbacks.length; i++)
      {
        if(callbacks[i] === callback)
          this.events[eventName].splice(i, 1);
      }
    }
  },

  //'eventData' allows for arbitrary event data to be passed to callback
  triggerEvent: function(eventName, eventData)
  {
    //console.log("triggering event '" + eventName + "'");
    this.events = this.events || {};

    var evt = {
      type: eventName,
      target: this,
      data: {}
    };

    if(eventData)
      $.extend(evt.data, eventData);

    var callbacks = this.events[eventName];

    if(callbacks)
    {
      var executeCallback = function(cb, evt)
      {
        cb(evt);
      };

      //queue up the callbacks
      for(var i = 0; i < callbacks.length; i++)
        setTimeout(executeCallback, 0, callbacks[i], evt);
    }
  }
};
